import React from 'react';
import { Form, Input, Select, Button, Alert, Space } from 'antd';
import { PhoneOutlined, RobotOutlined } from '@ant-design/icons';

const { Option } = Select;

const MappingForm = ({ templates, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <div>
      <Alert
        message="Important"
        description="Enter YOUR BOT'S WhatsApp number that RECEIVES messages from customers. Different bot numbers can act as different departments."
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Bot's WhatsApp Number"
          name="phoneNumber"
          rules={[
            { required: true, message: 'Please enter the bot\'s phone number' },
            { 
              pattern: /^\d+@c\.us$/, 
              message: 'Format: 1234567890@c.us (numbers only, followed by @c.us)' 
            }
          ]}
          extra="Format: 1234567890@c.us (this is YOUR BOT'S number that receives messages)"
        >
          <Input 
            prefix={<PhoneOutlined />}
            placeholder="1234567890@c.us" 
            size="large"
          />
        </Form.Item>

        <Form.Item
          label="Assign to Agent Template"
          name="templateId"
          rules={[{ required: true, message: 'Please select a template' }]}
          extra="Choose which agent this bot number will use"
        >
          <Select 
            placeholder="Select agent template"
            size="large"
            showSearch
            optionFilterProp="children"
          >
            {templates.map(template => (
              <Option key={template.templateId} value={template.templateId}>
                <Space>
                  <RobotOutlined />
                  <strong>{template.agentName}</strong>
                  <span style={{ color: '#999' }}>({template.templateId})</span>
                </Space>
              </Option>
            ))}
          </Select>
        </Form.Item>

        <div 
          style={{ 
            padding: 16, 
            background: '#f0f5ff', 
            borderRadius: 8, 
            marginBottom: 24,
            border: '1px solid #d6e4ff'
          }}
        >
          <strong style={{ display: 'block', marginBottom: 8 }}>💡 Examples:</strong>
          <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13 }}>
            <li>Bot number: 1234567890@c.us → Travel Insurance Agent</li>
            <li>Bot number: 9876543210@c.us → Customer Support Agent</li>
            <li>Bot number: 5555555555@c.us → Sales Agent</li>
          </ul>
        </div>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={onCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" size="large">
            Create Mapping
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default MappingForm;

